module.exports = __webpack_public_path__ + "static/media/Compras10.8c930cbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancCompras/Compras10.png
// module id = 2076
// module chunks = 0